/* eslint-disable no-console */
import xmlrpc from 'xmlrpc';

export default {
  callNativeXMLRPCRoutine(method, path, callback) {
    let options = {
      url: `${localStorage.proxyURL}/xmlrpcproxy`,
      headers: {
        Authorization: localStorage.credentials,
        Clusterip: localStorage.ip_address,
        Xmlrpcpath: `/cluster1${path}`,
      },
    };
    let xmlrpc_client = xmlrpc.createSecureClient(options);
    xmlrpc_client.methodCall(method, [], function (error, value) {
      callback(value, error);
    });
  },

  callPlugin(parameters, callback) {
    let options = {
      url: `${localStorage.proxyURL}/xmlrpcproxy`,
      headers: {
        Authorization: localStorage.credentials,
        Clusterip: localStorage.ip_address,
        Xmlrpcpath: '/cluster1',
      },
    };
    let xmlrpc_client = xmlrpc.createSecureClient(options);
    xmlrpc_client.methodCall(
      'callPlugin',
      [localStorage.pluginVersion, 'n0010', 'CLOUDUI_REQUEST', parameters],
      function (error, value) {
        if (error) {
          console.log('error:', error);
        } else {
          console.log('value:', value);
        }
        callback(value, error);
      }
    );
  },

  scalingRequest(parameters, randomString) {
    let options = {
      url: `${localStorage.proxyURL}/scalingrequest`,
      headers: {
        Authorization: localStorage.credentials,
        Clusterip: localStorage.ip_address,
        Xmlrpcpath: '/cluster1',
        Randomstring: randomString,
      },
    };
    let xmlrpc_client = xmlrpc.createSecureClient(options);
    xmlrpc_client.methodCall(
      'callPlugin',
      [localStorage.pluginVersion, 'n0010', 'CLOUDUI_REQUEST', parameters],
      function (error, value) {
        if (error) {
          console.log('error:', error);
        } else {
          console.log('value:', value);
        }
      }
    );
  },
};
